"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var app_base_1 = require("@aperza/app-base");
var util_1 = require("@aperza/util");
var HeaderLoader_1 = require("./component/header/HeaderLoader");
var Footer_1 = require("./component/footer/Footer");
var SuggestLoader_1 = require("./component/suggest/SuggestLoader");
var ShippingPriceLoader_1 = require("./component/marketplace/shippingPrice/ShippingPriceLoader");
var SellerGroupModelListLoader_1 = require("./component/marketplace/sellerGroupModel/SellerGroupModelListLoader");
var SellerShippingPriceLoader_1 = require("./component/marketplace/sellerShippingPrice/SellerShippingPriceLoader");
var CatalogVideoModal_1 = require("./component/catalog/video/CatalogVideoModal");
var CatalogCluezDownloadModalLoader_1 = require("./component/catalog/cluezDownload/CatalogCluezDownloadModalLoader");
var CatalogPartnerCardLoader_1 = require("./component/catalog/partner/CatalogPartnerCardLoader");
var CatalogPreviewModal_1 = require("./component/catalog/preview/CatalogPreviewModal");
var ContentLoader_1 = require("./component/content/ContentLoader");
app_base_1.initializeI18N();
var appConfig = util_1.AppService.appConfig();
var apolloClientHeader = app_base_1.createApolloClient('aperza-app-search-header');
var apolloClientSuggest = app_base_1.createApolloClient('aperza-app-search-suggest');
var apolloClientShippingPrice = app_base_1.createApolloClient('aperza-app-search-shippingPrice');
var apolloClientSellerGroupModelList = app_base_1.createApolloClient('aperza-app-search-sellerGroupModelList');
var apolloClientSellerShippingPrice = app_base_1.createApolloClient('aperza-app-search-sellerShippingPrice');
var apolloClientPartner = app_base_1.createApolloClient('aperza-app-search-partner');
var apolloClientContent = app_base_1.createApolloClient('aperza-app-search-content');
var start = function () {
    HeaderLoader_1.renderHeader(apolloClientHeader);
    Footer_1.renderFooter();
    SuggestLoader_1.renderSuggestLoader(apolloClientSuggest);
    ShippingPriceLoader_1.renderShippingPrice(apolloClientShippingPrice);
    SellerGroupModelListLoader_1.renderSellerGroupModelList(apolloClientSellerGroupModelList);
    SellerShippingPriceLoader_1.renderSellerShippingPrice(apolloClientSellerShippingPrice);
    if (util_1.PathUtil.isCatalogPage(util_1.PathUtil.currentPath(), appConfig.langCode)) {
        /// TODO : check API + Logged IN User for the Partner Card
        CatalogPartnerCardLoader_1.renderCatalogPartnerCard(apolloClientPartner);
    }
    ContentLoader_1.renderContent(apolloClientContent);
    if (util_1.AppConfigService.isAperzaCompanyPage() || util_1.AppConfigService.getCustomPageComponentElement()) {
        CatalogPreviewModal_1.renderCatalogPreviewModal();
        CatalogVideoModal_1.renderCatalogVideoModal();
        if (typeof $ !== 'undefined') {
            CatalogCluezDownloadModalLoader_1.renderCatalogCluezDownloadModal();
        }
    }
};
start();
